module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user && _vm.logoutSuccess) ? _c('h3', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left "
  }), _c('i', {
    staticClass: "fa fa-chevron-left "
  }), _c('i', {
    staticClass: "fa fa-chevron-left "
  }), _vm._v("\n            Logging out ..\n            "), _c('i', {
    staticClass: "fa fa-chevron-left "
  }), _c('i', {
    staticClass: "fa fa-chevron-left "
  }), _c('i', {
    staticClass: "fa fa-chevron-left "
  })]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-716462d9", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-716462d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Logout.vue